import React from "react";
import PropTypes from "prop-types";

import { Header } from "semantic-ui-react";

import { RichTextEditor } from "components/RichTextEditor";

export function DescriptionMarkup({ name, value, onChange, ...props }) {
  return (
    <div style={{ marginBottom: "1em" }}>
      <Header as="h3" style={{ marginBottom: "0.5em" }}>
        Description
      </Header>
      <div>
        <React.Fragment>
          <RichTextEditor
            placeholder="Add a description... (optional)"
            defaultValue={value}
            onChange={(content) => {
              onChange(null, { ...props, name: name, value: content });
            }}
            style={{ marginBottom: "0.5em" }}
          />
        </React.Fragment>
      </div>
    </div>
  );
}

DescriptionMarkup.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DescriptionMarkup;
